import React from "react";
import Select from "react-select";
import cx from "classnames";
import Glyphicon from "react-bootstrap/lib/Glyphicon";

// Be sure to include styles at some point, probably during your bootstrapping
import "react-select/dist/react-select.css";
import css from "./styles.less";

class SelectDropDown extends React.Component {
	state = {
		menuOuterStyle: {
			transition: "all 250ms ease",
			transformOrigin: "top",
			transform: "scaleY(0)"
		}
	};

	extraOptionProps = {
		className: css.selectOption
	};

	handleOnChange = selected => {
		if (!selected) return;
		const { onChange } = this.props;
		onChange && onChange(this.decodeOption(selected));
	};

	filterOption = option => {
		if (option.optionType === "Region") {
			if (typeof option.label !== "string" || option.label.trim().length == 0)
				return false;
		}
		return true;
	};

	renderOption = option => {
		const { titles } = this.props;

		switch (option.optionType) {
			case "City":
			case "AllHotels":
				return <div className={cx(css.boldedOption)}>{option.label}</div>;
			case "Region":
				return (
					<div className={cx(css.boldedOption)}>
						{`${!!titles.Region ? titles.Region : ""} ${option.label}`}
					</div>
				);
			default:
				// all other options render as is
				return <div className={css.indent}>{option.label}</div>;
		}
	};

	scaleUp = () => {
		this.setState(prev => ({
			menuOuterStyle: {
				...prev.menuOuterStyle,
				transform: "scaleY(1)"
			}
		}));
	};

	scaleDown = () => {
		this.setState(prev => ({
			menuOuterStyle: {
				...prev.menuOuterStyle,
				transform: "scaleY(0)"
			}
		}));
	};

	uniquOptions = options => {
		return options.map(option => {
			const encodedOption = this.encodeOption(option);
			return {
				...option,
				value: encodedOption.value,
				...this.extraOptionProps
			};
		});
	};

	encodeOption = option => {
		if (!option.value || !option.optionType) {
			return option;
		}
		return {
			...option,
			value: `${option.value}_${option.optionType}`
		};
	};

	decodeOption = encodedOption => {
		// remove '_OptionType' from option value
		const _index = encodedOption.value.indexOf("_");
		// check if value is encoded (if nedd to pass thorugh decode)
		const notEncoded = _index === -1;
		if (notEncoded) {
			return encodedOption;
		}
		const decodedValue = encodedOption.value.substring(0, _index);
		return {
			...encodedOption,
			value: decodedValue
		};
	};

	render() {
		const {
			placeholder,
			notValid,
			options,
			selectedOption,
			openDirection
		} = this.props;

		// we use state in order to inject extra properties to the options,
		// props are owned by their parent hence they are readonly!
		const mappedOptions = this.uniquOptions(options);
		const selectedValue =
			selectedOption && this.encodeOption(selectedOption).value;

		const { menuOuterStyle } = this.state;
		return (
			<Select
				{...this.props}
				className={cx(
					css.selectDropdown,
					css.forXs,
					notValid && css.notValid,
					openDirection == "up" && css.upDirection,
					"sbox__select-dropdown"
				)}
				name="form-field-name"
				value={selectedValue}
				resetValue="..."
				placeholder={placeholder}
				options={mappedOptions}
				onChange={this.handleOnChange}
				backspaceRemoves={false}
				deleteRemoves={false}
				optionRenderer={this.renderOption}
				//filterOption={this.filterOption}
				menuContainerStyle={menuOuterStyle}
				onOpen={this.scaleUp}
				onClose={this.scaleDown}
				clearable={false}
				searchable
				isOpen={true}
			/>
		);
	}
}

SelectDropDown.defaultProps = {
	options: [
		{
			value: "item1",
			label: "item 1",
			extraProp: "item",
			className: css.selectOption
		},
		{
			value: "item2",
			label: "item 2",
			extraProp: "item",
			className: css.selectOption
		},
		{
			value: "item3",
			label: "item 3",
			extraProp: "item",
			className: css.selectOption
		}
	]
};

export default SelectDropDown;



// WEBPACK FOOTER //
// ./src/components/SelectDropDown/SelectDropDown.js